"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunningBackground = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const className = (0, nano_theme_1.drule)({
    h: '2px',
    bgs: '102px 2px',
    an: 'bg-running 2s infinite linear',
    '@keyframes bg-running': {
        '0%': {
            bgp: '0 0',
        },
        '100%': {
            bgp: '102px 0',
        },
    },
});
const RunningBackground = ({ children }) => {
    const styles = (0, context_1.useStyles)();
    const base = styles.g(0.86);
    const stripe = styles.g(0.8);
    return (React.createElement("div", { className: className({
            bg: `repeating-linear-gradient(45deg, ${base} 0, ${base} 4px, ${stripe} 4px, ${stripe} 8px)`,
        }) }, children));
};
exports.RunningBackground = RunningBackground;
